(() => {
  'use strict';

  const isHomepage = () => window.location.pathname === '/' || window.location.pathname === '';

  const indicators = new Map();

  const initIndicators = () => {
    document.querySelectorAll('.menu-quicklinks').forEach(section => {
      const container = section.querySelector('.menu-quicklinks__container');
      const indicator = section.querySelector('.menu-quicklinks__indicator');
      if (!container || !indicator) return;

      const update = () => {
        const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 4;
        indicator.classList.toggle('menu-quicklinks__indicator--hidden', atEnd);
      };

      indicator.addEventListener('click', () => {
        container.scrollBy({ left: 160, behavior: 'smooth' });
      });

      container.addEventListener('scroll', update, { passive: true });
      indicators.set(section, update);
    });
  };

  const getTargets = (identifier) => {
    if (!identifier) {
      return document.querySelectorAll('.menu-quicklinks');
    }

    let searchTerm = identifier;
    if (identifier.includes('__')) {
      searchTerm = identifier.split('__').pop();
    }

    const selector = `shopify-section[id*="${searchTerm}"], section[id*="${searchTerm}"], [id*="${searchTerm}"], .menu-quicklinks`;

    return document.querySelectorAll(selector);
  };

  window.convertMenuQuicklinks = {
    control: function(identifier = null) {
      getTargets(identifier).forEach(el => el.classList.remove('is-visible'));
    },

    variant: function(identifier = null) {
      if (!isHomepage()) return;
      
      getTargets(identifier).forEach(el => {
        el.classList.add('is-visible');
        indicators.get(el)?.();
      });
    },

    reset: function(identifier = null) {
      this.control(identifier);
    }
  };

  const init = () => {
    window.convertMenuQuicklinks.control();
    initIndicators();
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('page:load', init);
  document.addEventListener('shopify:section:load', init);

})();